import { Button, Card, Col, Container, Image, Row } from "react-bootstrap";
import { Link } from "react-router-dom";

import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import NotFoundImage from "../../assets/img/illustrations/404.svg";
import { routes } from "../../constants";

export const InvalidInvitation = ({ errors }: { errors?: any }) => (
	<main>
		<section className="vh-100 d-flex align-items-center justify-content-center">
			<Container>
				<Row>
					<Col
						xs={12}
						className="text-center d-flex align-items-center justify-content-center"
					>
						<div>
							<Card.Link
								as={Link}
								to={routes.dashboardOverview.path}
							>
								<Image
									src={NotFoundImage}
									className="img-fluid w-75"
								/>
							</Card.Link>
							<h1 className="text-primary mt-5">
								Invalid Invitation
							</h1>
							{errors ? (
								<>
									{errors.map((e: any, index: number) => (
										<p className="lead my-4" key={index}>
											{e?.message}
										</p>
									))}
								</>
							) : (
								<p className="lead my-4">
									Oops! Looks like you followed a bad link. If
									you think this is a problem with us, please
									tell us.
								</p>
							)}
							<Link to={routes.dashboardOverview.path}>
								<Button
									variant="primary"
									className="animate-hover"
								>
									<FontAwesomeIcon
										icon={faChevronLeft}
										className="animate-left-3 me-3 ms-2"
									/>
									Go back home
								</Button>
							</Link>
						</div>
					</Col>
				</Row>
			</Container>
		</section>
	</main>
);
